import { jsx as e, jsxs as a } from "react/jsx-runtime";
import { useTranslation as m } from "react-i18next";
import { LoadingEnum as s, isDefined as g } from "@perxis-auto/shared";
import { useCurrentStage as u, useStages as h } from "@perxis-auto/trade-in-sdk";
import { StageEntityId as _ } from "@perxis-auto/trade-in-sdk/types";
import { Disclaimer as f } from "@perxis-auto/ui-kit";
import { Row as t, Col as r } from "@perxis-auto/ui-kit/lib/components/Grid";
import { Typography as l } from "@perxis-auto/ui-kit/lib/components/Typography";
import { APP as v } from "../../../shared/config/app.js";
import { STAGE_NUMBER_MAP as o, GET_STAGE_TITLE_MAP as T, MAX_STAGE_NUMBER as S } from "../../../shared/config/stages.js";
import { Loader as E } from "../../../shared/ui/Loader/Loader.js";
import x from "./AppLayout.module.scss.js";
function j({ children: c }) {
  const { current: n } = u(), { service: i, loading: d } = h(), { t: p } = m(v.name);
  return [s.Idle, s.Pending].includes(d) ? /* @__PURE__ */ e(t, { gutter: [0, "vertical-green"], className: x.loaderContainer, children: /* @__PURE__ */ e(r, { span: 24, children: /* @__PURE__ */ e(E, {}) }) }) : /* @__PURE__ */ a(t, { gutter: [0, "vertical-green"], children: [
    !!n && g(o[n]) && /* @__PURE__ */ e(r, { span: 24, className: "pa-trade-in-step", children: /* @__PURE__ */ e(l.Title, { className: "pa-trade-in-step__title", color: "darkest", level: "h4", children: p("stageHeader.step", {
      current: o[n],
      max: S,
      name: T(n)
    }) }) }),
    /* @__PURE__ */ e(r, { span: 24, children: /* @__PURE__ */ a(t, { gutter: [0, "vertical-red"], children: [
      /* @__PURE__ */ e(r, { span: 24, children: c }),
      !!i && /* @__PURE__ */ e(r, { span: 24, className: "pa-trade-in-service", children: /* @__PURE__ */ a(t, { gutter: [0, "vertical-green"], children: [
        /* @__PURE__ */ a(t, { gutter: [0, "vertical-purple"], children: [
          i.description && /* @__PURE__ */ e(r, { span: 24, children: /* @__PURE__ */ e(l.Text, { className: "pa-trade-in-service__description", color: "dark-light", level: "small", children: /* @__PURE__ */ e("span", { dangerouslySetInnerHTML: { __html: i.description } }) }) }),
          !!i.logo_url && /* @__PURE__ */ e(r, { span: 24, children: /* @__PURE__ */ e(t, { gutter: [18, "vertical-purple"], children: /* @__PURE__ */ e(r, { children: /* @__PURE__ */ e("img", { src: i.logo_url, alt: i.id }) }) }) })
        ] }),
        n === _.SUCCESS && i.disclaimer_text && /* @__PURE__ */ e(r, { span: 24, children: /* @__PURE__ */ e(f, { children: /* @__PURE__ */ e(
          l.Text,
          {
            className: "pa-trade-in-service__disclaimer",
            color: "dark-light",
            level: "super-small",
            children: /* @__PURE__ */ e("span", { dangerouslySetInnerHTML: { __html: i.disclaimer_text.replace(">", ">*&nbsp;") } })
          }
        ) }) })
      ] }) })
    ] }) })
  ] });
}
export {
  j as AppLayout
};
